import React from 'react';
import PropTypes from 'prop-types';
import { BlockButton, BlockButtonGroup } from '../ui/Block';
import FormGroup from '../ui/FormGroup';
import { Client } from '../../client';

const ThreadComponent = (options) => {
    let type = null
    if (options.meta.valid) {
        type = "success"
    } else if (options.meta.visited) {
        type = "error"
    }
    return (
        <FormGroup label={options.label}>
            <BlockButtonGroup
                {...options.input}
                id={options.input.name}
                onChange={(event, value) => {
                    options.input.onChange(value)
                }}
                onBlur={() => {
                    options.input.onBlur()
                }}
            >
                {options.values.map((item, i) => (
                    <BlockButton
                        key={item.attrValue}
                        attrValue={''}
                        id={options.input.name}
                        labelTextInner={'true'}
                        value={item.attrValue}
                        variation={'image'}
                        imageUrl={Client.getRemarkImageUrlButtonThread(item.attrValue)}
                        labelText={item.shortName}>
                    </BlockButton>
                ))}
            </BlockButtonGroup>
        </FormGroup>
    )
}

ThreadComponent.propTypes = {
    label: PropTypes.string,
    input: PropTypes.object.isRequired,
    values: PropTypes.array.isRequired,
}

export default ThreadComponent;